<template>
  <div>
    <button class="p-link layout-signout-button">
            <span class="pi pi-shopping-cart" v-on:click="openPosition('topright')">
            </span>
    </button>
    <span v-if="getChartCount > 0" class="layout-topbar-badge">{{ getChartCount }}</span>
    <Dialog :header="translate('header.basket')" :modal="true" :position="position" :style="{width: '30vw'}"
            :visible.sync="displayPosition">
      <DataTable :scrollable="true"
                 :value="getChartList"
                 class="profile-table"
                 dataKey="basemasterGUID"
                 scroll-height="500px"
                 selectionMode="single">
        <Column header="Original title">
          <template #body="slotProps">
            <div class="centered-left">
              {{ slotProps.data.originalTitle }}
            </div>
            <div class="centered-right">
              <Button class="p-button-secondary"
                      icon="pi pi-trash"
                      v-on:click="chartItemClick(slotProps.data)"></Button>
            </div>
          </template>
        </Column>
      </DataTable>
      <div style="text-align: right">
        <Button :label="translate('create.offer')" class="p-mt-2" v-on:click="goTo()"></Button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TranslateService from "../services/translate.service";
import router from "../router";

export default {
  name: "ShoppingCard",
  data() {
    return {
      clickedItem: null,
      displayBasic: false,
      displayBasic2: false,
      displayModal: false,
      displayMaximizable: false,
      displayPosition: false,
      position: 'center'
    }
  },
  computed: {
    ...mapGetters('offer',
        ['getChartList', 'getChartCount']),
    ...mapGetters('config',
        ['featureActive']),
  },
  methods: {
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    ...mapActions('offer', [
      'addToOffer', 'deleteChartItem'
    ]),
    openPosition(position) {
      this.position = position;
      this.displayPosition = true;
    },
    chartItemClick(item) {
      this.clickedItem = item;
      this.deleteChartItem(item)
    },
    translate(message) {
      return TranslateService.translateMessage(message);
    },
    goTo() {
      if (this.featureActive("externalOffers")) {
        location.href = "/offers/new";
      } else {
        router.push('/offer/new')
      }
      this.displayPosition = false
    },
  }
}
</script>

<style scoped>

.layout-topbar-badge {
  position: absolute;
  font-size: 10px;
  right: 50px;
  top: 5px;
  padding-left: 5px;
  padding-right: 5px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  color: white;
  background-color: #bf2538;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

</style>